import React, { useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { CheckoutPage } from './pages/CheckoutPage';
export function App() {
  const [currentPage, setCurrentPage] = useState<'landing' | 'checkout'>('landing');
  const goToCheckout = () => {
    setCurrentPage('checkout');
    window.scrollTo(0, 0);
  };
  const goToLanding = () => {
    setCurrentPage('landing');
    window.scrollTo(0, 0);
  };
  if (currentPage === 'checkout') {
    return <CheckoutPage onBack={goToLanding} data-id="element-0" />;
  }
  return <LandingPage onCheckout={goToCheckout} data-id="element-1" />;
}